/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDfmTrackingProviders.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/dfm-tracking-providers";

export class AutogenModelDfmTrackingProviders<RowType extends ModelRow> extends Endpoint<RowType, RowDfmTrackingProvidersFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDfmTrackingProviders extends ModelRow<RowDfmTrackingProvidersFields> {
	constructor(values?: Partial<RowDfmTrackingProvidersFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDfmTrackingProvidersFields {
	code_type: string;
	company_id: string;
	description: string;
	display_value: string;
	id: string;
}

